import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Slides from '@ifeng-fe/ui_pc_slides';
import { formatUrl, formatImage } from '@ifeng-fe/public_method';
import styles from './index.css';
import { rel as relText } from '../../../utils/rel';

class Slide extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    constructor(...argu) {
        super(...argu);

        const data = this.formatData(this.props.content);

        data[0].isItem = true;

        this.state = { data };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.content !== nextProps.content) {
            const { content } = nextProps;
            const data = this.formatData(this.props.content);

            this.setState({ data });
        }
    }
    formatData(data) {
        data.forEach((value, index) => {
            value.index = index;
        });

        return data;
    }
    afterChange(currentIndex, total) {
        const { data } = this.state;

        for (const item of data) delete item.isItem;

        data[currentIndex].isItem = true;

        this.setState({ data: [...data] });
    }
    sliderTmplView(item) {
        const url = formatUrl(item.url);

        return (
            <a className={styles.lunboBox} href={url} target="_blank" rel={relText} ifeng_ui_pc_sliders-link="">
                {item.isItem ? null : <div className={styles.mask} />}
                <img
                    className={item.isItem ? null : styles.image}
                    src={formatImage(item.thumbnails, 650, 400)}
                    alt={item.title}
                    width={650}
                    height={400}
                    ifeng_ui_pc_sliders-image=""
                />
                {item.isItem ? (
                    <div className={styles.title} ifeng_ui_pc_sliders-title="">
                        <p>{item.title}</p>
                    </div>
                ) : null}
            </a>
        );
    }
    render() {
        const { data } = this.state;

        return (
            <div className={styles.slide}>
                <Slides
                    content={data}
                    config={{
                        sliderTmpl: this.sliderTmplView.bind(this),
                        dotStyle: styles.dot,
                        dotCurrentStyle: styles.dotCurrentStyle,
                        autoplay: false,
                        unitSize: 650,
                        padding: 1,
                        autoplayInterval: 5000,
                        afterChange: this.afterChange.bind(this),
                    }}
                />
            </div>
        );
    }
}

export default Slide;
